import DynamicClinicText from './DynamicClinicText';

export default DynamicClinicText;
